import React from 'react';
import { observer } from 'mobx-react-lite';
import { dialogStore } from './dialogStore';

/**
 * Renders every dialog currently in `dialogStore`. Mount this once,
 * somewhere stable in the app tree (e.g., next to `<ToastContainer />`
 * in `src/index.tsx`). The component is an `observer`, so it
 * re-renders whenever the store's dialog list changes.
 */
export const DialogMount = observer(() => (
  <>
    {dialogStore.dialogs.map((d) => (
      <React.Fragment key={d.id}>{d.node}</React.Fragment>
    ))}
  </>
));
